import { TOAST_TYPE } from "../../constants/toast";
import { HIDE_TOAST, SHOW_TOAST } from "../../constants/action-types";

export const showToast = (
  dispatch,
  messageKey,
  type = TOAST_TYPE.success,
  variables = {}
) => {
  dispatch({
    type: SHOW_TOAST,
    payload: { messageKey, type, variables },
  });
};

export const hideToast = (dispatch) => {
  dispatch({ type: HIDE_TOAST });
};
